module.exports = (__webpack_require__(28912))(1248);